var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.globalLoading || _vm.picShareLoading)?_c('div',{staticClass:"loading-wrapper"},[(_vm.globalLoading)?_c('div',{staticClass:"img"}):_c('div',{staticClass:"picShareLoading"},[_vm._v("图片生成中...")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }